var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag:common", arg: "common" }],
      attrs: {
        title: "导入边界",
        visible: _vm.visible,
        "show-close": false,
        width: "400px"
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "boundaryImport",
          staticClass: "demo-form-inline",
          attrs: { model: _vm.formData, rules: _vm.rules }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "风场边界",
                "label-width": "80px",
                prop: "fileId"
              }
            },
            [
              _c(
                "el-upload",
                {
                  ref: "uploadFile",
                  attrs: {
                    limit: 1,
                    action: _vm.action,
                    data: { file: "file", apiKey: _vm.getToken(), type: 8 },
                    "on-success": (response, file, fileList) =>
                      _vm.onFileUploadSuccess(
                        response,
                        file,
                        fileList,
                        "fileId"
                      ),
                    "file-list": _vm.fileListMap.fileIdList,
                    "on-remove": (file, fileList) =>
                      _vm.removeFile(file, fileList, "fileId"),
                    "on-change": (file, fileList) =>
                      _vm.handleChange(file, fileList, "fileId"),
                    accept: ".kmz"
                  }
                },
                [
                  _c(
                    "ct-button",
                    { attrs: { type: "primary", size: "small" } },
                    [_vm._v("点击上传")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "ct-button",
            { attrs: { "btn-click": _vm.close, size: "small" } },
            [_vm._v("取 消")]
          ),
          _c(
            "ct-button",
            {
              attrs: { type: "primary", "btn-click": _vm.submit, size: "small" }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }